export const GET_QA_SPEC_DATA_HEADER = '/api/pim/get-qa-spec-data-header';
export const SAVE_QA_SPEC_DATA_HEADER = '/api/pim/save-qa-spec-data-header';

export const GET_QA_SPEC_PRODUCT_SPEC =
    '/api/pim/get-qa-spec-data-product-specification';
export const SAVE_QA_SPEC_PRODUCT_SPEC =
    '/api/pim/save-qa-spec-data-product-specification';
export const UPDATE_QA_SPEC_PRODUCT_SPEC_DOCUMENT =
    '/api/pim/update-qa-spec-data-product-specification-document';

export const GET_QA_SPEC_ORGANOLEPTIC_CHARACTERISTIC =
    '/api/pim/get-qa-spec-data-organoleptic-characteristics';
export const SAVE_QA_SPEC_ORGANOLEPTIC_CHARACTERISTIC =
    '/api/pim/save-qa-spec-data-organoleptic-characteristics';

export const GET_QA_SPEC_CONTAMINANT_CHARACTERISTIC =
    '/api/pim/get-qa-spec-data-contaminant-characteristics';
export const SAVE_QA_SPEC_CONTAMINANT_CHARACTERISTIC =
    '/api/pim/save-qa-spec-data-contaminant-characteristics';

export const GET_QA_SPEC_PHY_CHE_CHARACTERISTIC =
    '/api/pim/get-qa-spec-data-physical-and-chemical-characteristics';
export const SAVE_QA_SPEC_PHY_CHE_CHARACTERISTIC =
    '/api/pim/save-qa-spec-data-physical-and-chemical-characteristics';

export const GET_QA_SPEC_MICROBIOLOGICAL_CHARACTERISTIC =
    '/api/pim/get-qa-spec-data-microbiological-characteristics';
export const SAVE_QA_SPEC_MICROBIOLOGICAL_CHARACTERISTIC =
    '/api/pim/save-qa-spec-data-microbiological-characteristics';

export const GET_QA_SPEC_DOCUMENT =
    '/api/pim/get-qa-spec-data-product-specification-documents';
export const LINK_QA_SPEC_DOCUMENT =
    '/api/pim/link-qa-spec-data-product-specification-document';
export const UNLINK_QA_SPEC_DOCUMENT =
    '/api/pim/unlink-qa-spec-data-product-specification-document';
export const GET_SPEC_DATA_MANUFACTURING_PROCESS =
    '/api/pim/get-qa-spec-data-manufacturing-processes';
export const SAVE_SPEC_DATA_MANUFACTURING_PROCESS =
    '/api/pim/save-qa-spec-data-manufacturing-processes';

export const GET_SPEC_DATA_MANUFACTURING_LOCATION =
    '/api/pim/get-qa-spec-data-manufacturing-locations';
export const SAVE_SPEC_DATA_MANUFACTURING_LOCATION =
    '/api/pim/update-qa-spec-data-manufacturing-locations';

export const GET_SPEC_DATA_MANUFACTURING_PROCESS_DOCUMENT =
    '/api/pim/get-qa-spec-data-manufacturing-process-documents';
export const GET_SPEC_FACILITY_CONTACTS =
    '/api/pim/get-qa-spec-facility-contacts';
export const LINK_QA_SPEC_MANUFACTURING_PROCESS_DOCUMENT =
    '/api/pim/link-qa-spec-data-manufacturing-process-document';
export const UNLINK_QA_SPEC_MANUFACTURING_PROCESS_DOCUMENT =
    '/api/pim/unlink-qa-spec-data-manufacturing-process-document';
export const UPDATE_QA_SPEC_MANUFACTURING_PROCESS_DOCUMENT =
    '/api/pim/update-qa-spec-data-manufacturing-process-document';

export const GET_QA_SPEC_DATA_CONTACT = '/api/pim/get-product-contacts';
export const GET_QA_SPEC_DATA_CONTACT_SNAPSHOT =
    '/api/pim/snapshot/get-qa-spec-contacts';

export const SAVE_QA_SPEC_DATA_CONTACT = '/api/pim/save-qa-spec-data-contacts';

export const GET_QA_SPEC_CORRECTIVE_ACTIONS =
    '/api/car/get-car-qa-evalform-data';
export const SAVE_QA_SPEC_CORRECTIVE_ACTION =
    '/api/car/save-car-qa-evalform-data';
export const SEND_REQUEUE_EMAIL = '/api/car/requeue-email-car-qaspec';

export const UPDATE_DOCS_OR_CERTIFICATION =
    '/api/pim/qa-spec-update-document-or-certificate';

export const GET_DOWNLOAD_QA_SPEC_URL = '/api/pim/download-qa-spec-form';

// QA Evaluation Form
export const GET_QA_EVALUATION_FORM = '/api/pim/evaluation-form';

//QA Organoleptic Findings
export const EXPORT_QA_ORGANOLEPTIC_FINDINGS = '/api/pim/export-qa-spec-eval-organoleptic-findings';

// QA Evaluation Form Multipack
export const GET_QA_EVALUATION_FORM_MULTIPACK =
    '/api/pim/evaluation-form-multipack';

export const SAVE_DRAFT_QA_SPEC_EVALUATION_FORM_MULTIPACK =
  '/api/pim/save-draft-qa-spec-evaluation-form-multipack';

export const SAVE_DRAFT_QA_SPEC_EVALUATION_FORM =
    '/api/pim/save-draft-qa-spec-evaluation-form';

export const DELETE_DRAFT_QA_SPEC_EVALUATION_FORM =
    '/api/pim/delete-draft-qa-spec-evaluation-form';

export const DOWNLOAD_QA_SPEC_FORM = '/api/pim/download-qa-spec-form';

export const UPLOAD_QA_EVALUATION_FORM_ASSET =
    '/api/pim/upload-qa-evaluation-form-asset';

export const SAVE_QA_SPEC_EVALUATION_FORM_MULTIPACK =
  '/api/pim/save-qa-spec-evaluation-form-multipack';

export const SAVE_QA_SPEC_EVALUATION_FORM =
    '/api/pim/save-qa-spec-evaluation-form';

export const UNLINK_QA_SPEC_EVALUATION_FORM_ASSET =
    '/api/pim/unlink-qa-spec-evaluation-form-asset';

export const GET_QA_SPEC_COMPONENTS = '/api/pim/get-qa-spec-data-components';
export const GET_QA_SPEC_COMPONENTS_SNAPSHOT =
    '/api/pim/snapshot/get-qa-spec-components';
export const SAVE_QA_SPEC_COMPONENTS = '/api/pim/save-qa-spec-data-components';

export const ADD_CUSTOM_ALLERGEN = '/api/pim/save-qa-spec-allergens-item';

export const LINK_QA_SPEC_PRODUCT_SPEC_CERTIFICATION =
    '/api/pim/link-qa-spec-data-product-specification-certification';

// produce - deli
export const GET_QA_SPEC_PRODUCE = '/api/pim/get-qa-spec-data-fresh-produce';
export const SAVE_QA_SPEC_PRODUCE = '/api/pim/save-qa-spec-data-fresh-produce';

export const GET_QA_SPEC_DELI = '/api/pim/get-qa-spec-data-fresh-deli';
export const GET_QA_SPEC_DELI_SNAPSHOT =
    '/api/pim/snapshot/get-qa-spec-fresh-deli';

export const SAVE_QA_SPEC_DELI = '/api/pim/save-qa-spec-data-fresh-deli';

export const GET_QA_SPEC_COMPANY_LOCATION =
    '/api/pim/get-qa-spec-company-locations';
export const SAVE_QA_SPEC_MANUFACTURING_LOCATION =
    '/api/pim/save-qa-spec-data-manufacturing-location';

// Pet food
export const GET_QA_SPEC_DATA_PET_FOOD = '/api/pim/get-qa-spec-data-pet-food';

export const SAVE_QA_SPEC_DATA_PET_FOOD = '/api/pim/save-qa-spec-data-pet-food';

export const GET_QA_PET_FOOD_SNAPSHOT =
    '/api/pim/snapshot/get-qa-spec-pet-food';

export const GET_QA_PET_NON_FOOD_SNAPSHOT =
    '/api/pim/snapshot/get-qa-spec-pet-non-food';

export const ADD_QA_SPEC_DATA_MANUFACTURING_LOCATION =
    '/api/pim/add-qa-spec-data-manufacturing-locations';

export const DELETE_QA_SPEC_DATA_MANUFACTURING_LOCATION =
    '/api/pim/delete-qa-spec-data-manufacturing-locations';

export const GET_PRODUCT_LOCATIONS = 'api/pim/get-product-locations';

export const GET_PRODUCT_CERTIFICATE = 'api/pim/get-product-certificates';

export const ADD_PRODUCT_CONTACT_LINKS = 'api/pim/save-product-contact-links';

export const DELETE_PRODUCT_CONTACT_LINKS =
    'api/pim/delete-product-contact-links';
export const GET_QA_SPEC_HISTORY = '/api/pim/get-qa-spec-status-history';

export const SAVE_QA_SPEC_PKG_MASTER_CASE =
  'api/pim/save-qa-spec-epr-packaging-master-case';

export const GET_QA_SPEC_MASTER_CASE =
  'api/pim/get-qa-spec-epr-packaging';

export const SAVE_QA_SPEC_PKG_RETAILER_UNIT =
  'api/pim/save-qa-spec-epr-packaging-retailer-unit';

export const GET_DYNAMIC_LOOK_UPS =
  'api/pim/dynamic-lookups';

export const DELETE_QA_SPEC_PKG_COMPONENT_MASTER_CASE
  = 'api/pim/delete-qa-spec-epr-packaging-master-case-component'

export const DELETE_QA_SPEC_PKG_COMPONENT_RETAILER_UNIT
  = 'api/pim/delete-qa-spec-epr-packaging-retailer-unit-component'

export const DOWNLOAD_QA_SPEC_TEMPLATE = '/api/pim/export-template-add-editing-bulk-products-qa-specs';

export const CHECK_QA_SPEC_TEMP_VISIBILITY_MEMBER = '/api/MemberProfile/get-qa-spec-bulk-upload-template-visibility-member'

//QA Sensory Findings
export const EXPORT_QA_SENSORY_FINDINGS = '/api/pim/export-qa-spec-eval-sensory-findings';

export const CHECK_USER_LIMIT_SENSORY_FINDINGS = '/api/pim/check-user-limit-sensory-findings';

export const GET_POWER_BI_DOWNLOAD_QA_SPEC_URL = '/api/powerbi/export';